module.exports = __webpack_public_path__ + "static/img/product-swipe7.6cd97726.png";